export default __webpack_public_path__ + "static/media/036-waves.de00b716.png";